export const convertDateTimeToString = (date: Date) => {
  const yyyy = String(date.getFullYear());
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const HH = String(date.getHours()).padStart(2, "0");
  const MM = String(date.getMinutes()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd} ${HH}:${MM}`;
};
export const convertDateToString = (date: Date) => {
  const yyyy = String(date.getFullYear());
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};
export const convertMonthToString = (date: Date) => {
  const yyyy = String(date.getFullYear());
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  return `${yyyy}年${mm}月`;
};
export const convertTimeToString = (date: Date) => {
  const HH = String(date.getHours()).padStart(2, "0");
  const MM = String(date.getMinutes()).padStart(2, "0");
  return `${HH}:${MM}`;
};
export const convertDateToJapaneseStringWithWeek = (date: Date) => {
  const yyyy = String(date.getFullYear());
  const mm = String(date.getMonth() + 1);
  const dd = String(date.getDate());
  const week = ['日','月','火','水','木','金','土'].at(date.getDay());
  return `${yyyy}年${mm}月${dd}日(${week})`;
}
export const convertDateToJapaneseStringWithWeekZero = (date: Date) => {
  const yyyy = String(date.getFullYear());
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const week = ['日','月','火','水','木','金','土'].at(date.getDay());
  return `${yyyy}年${mm}月${dd}日(${week})`;
}
export const convertDateToStringCompactFormat = (date: Date) => {
  const yyyy = String(date.getFullYear());
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}${mm}${dd}`;
}
export const convertDateToJapaneseString = (date: Date) => {
  const yyyy = String(date.getFullYear());
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}年${mm}月${dd}日`;
};
export const zeroPadding = (num:number, len:number) => {
	return ( Array(len).join('0') + num ).slice( -len );
};
export const convertDateToSlashTypeString = (date: Date) => {
  const yyyy = String(date.getFullYear());
  const mm = String(date.getMonth() + 1);
  const dd = String(date.getDate());
  return `${yyyy}/${mm}/${dd}`;
};
export const convertDateToSlashTypeZeroPadString = (date: Date) => {
  const yyyy = String(date.getFullYear());
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}/${mm}/${dd}`;
};
export const convertDateTimeToJapaneseStringWithWeekZero = (date: Date) => {
  const yyyy = String(date.getFullYear());
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const week = ['日','月','火','水','木','金','土'].at(date.getDay());
  const HH = String(date.getHours()).padStart(2, "0");
  const MM = String(date.getMinutes()).padStart(2, "0");
  return `${yyyy}年${mm}月${dd}日 (${week}) ${HH}：${MM}`;
}
export const convertDateTimeToJapaneseString = (date: Date) => {
  const yyyy = String(date.getFullYear());
  const mm = String(date.getMonth() + 1);
  const dd = String(date.getDate());
  const HH = String(date.getHours()).padStart(2, "0");
  const MM = String(date.getMinutes()).padStart(2, "0");
  return `${yyyy}年${mm}月${dd}日　${HH}：${MM}`;
}
export const convertDateTimeToStringCompactFormat = (date: Date) => {
  const year = String(date.getFullYear());
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  return `${year}${month}${day}${hour}${minute}`;
}
export const convertDateSecToStringCompactFormat = (date: Date) => {
  const year = String(date.getFullYear());
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  const second = String(date.getSeconds()).padStart(2, "0");
  return `${year}${month}${day}${hour}${minute}${second}`;
}
/**
 * 日付を文字列(日本語のフォーマット、日付と時刻の間・コロンは半角)に変換
 * @param date 日付
 * @returns フォーマット変換後の文字列
 */
export const convertDateTimeToJapaneseStringHalfwidth = (date: Date) => {
  const yyyy = String(date.getFullYear());
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const HH = String(date.getHours()).padStart(2, "0");
  const MM = String(date.getMinutes()).padStart(2, "0");
  return `${yyyy}年${mm}月${dd}日 ${HH}:${MM}`;
}
/**
 * 日付を文字列(日本語のフォーマット、年月のみ)に変換
 * @param date 日付
 * @returns フォーマット変換後の文字列
 */
export const convertDateTimeToJapaneseStringMonth = (date: Date) => {
  const yyyy = String(date.getFullYear());
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  return `${yyyy}年${mm}月`;
}
/**
 * 日付を文字列(日本語のフォーマット、年月日＋週、月日はゼロ埋め)に変換
 * @param date 
 * @returns フォーマット変換後の文字列
 */
export const convertDateToJapaneseStringWithWeekZeroPadding = (date: Date) => {
  const yyyy = String(date.getFullYear());
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const week = ['日','月','火','水','木','金','土'].at(date.getDay());
  return `${yyyy}年${mm}月${dd}日(${week})`;
}